import { useMutation } from "@apollo/client/react";
import { UPDATE_TEMPLATE_ROW_EXTRACTION } from "../../mutations/invoiceInterpretationTemplates/updateTemplateRowExtraction";
import type { InvoiceReaderTemplateRowExtractionModel } from "../../../models/ClientInvoiceReaderTemplateModel";
import type { TemplateRowExtractionInput } from "../../../models/InvoiceInterpretationInputs";

export const useUpdateTemplateRowExtraction = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: (error: any) => void;
}) => {
  const [mutation, { loading, error, data }] = useMutation(
    UPDATE_TEMPLATE_ROW_EXTRACTION,
    {
      onCompleted,
      onError,
    },
  );

  const updateTemplateRowExtraction = async ({
    rows,
    templateId,
    clientIdentifier,
    ignoredHeaders,
  }: {
    templateId?: string;
    clientIdentifier?: string;
    rows: InvoiceReaderTemplateRowExtractionModel[];
    ignoredHeaders?: string[];
  }) => {
    const input: TemplateRowExtractionInput = {
      columnExtractions: rows.map((row) => ({
        columnHeader: row.columnHeader
          ? {
              position: row.columnHeader.position,
              value: row.columnHeader.value,
            }
          : null,
        columnHeaderType: row.columnHeaderType,
        isFixedPosition: row.isFixedPosition ?? false,
      })),
      ignoredHeaders: ignoredHeaders,
    };

    return mutation({
      variables: {
        templateId,
        clientIdentifier,
        input,
      },
    });
  };

  return { updateTemplateRowExtraction, loading, error, data };
};
